import {
  ComunicazioneDTO,
  TipoComunicazioneDTO,
  TipoComunicazioneFileAllegatoDTO,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement } from '@framework/ui';
import { RcFile } from 'antd/es/upload';
import * as React from 'react';
import { ICommonCommunicationProps } from '../logic/ICommonCommunicationProps';
import { AttachmentGroupEditor } from './AttachmentGroupEditor';

interface CommunicationAttachmentFieldsProps {
  communication?: ComunicazioneDTO | null;
  communicationType: TipoComunicazioneDTO;
  uploadAttachment?: ICommonCommunicationProps<any, any>['uploadAttachment'];
  removeAttachment: ICommonCommunicationProps<any, any>['removeAttachment'];
  attachExisting?: ICommonCommunicationProps<any, any>['attachExisting'];
  taskId?: string;
}

export const CommunicationAttachmentFields = (
  props: CommunicationAttachmentFieldsProps,
) => {
  const {
    communication,
    communicationType,
    uploadAttachment,
    attachExisting,
    taskId,
  } = props;
  const { t } = useTranslation();
  //  Allegati possono essere caricati solo in una comunicazione già creata
  const disabled =
    communication == null || Object.keys(communication).length === 0;

  const attachmentGroupList = disabled
    ? communicationType.tipoComunicazioneFileAllegati
    : communication!.tipoComunicazione?.tipoComunicazioneFileAllegati;

  const handleUpload = async (
    file: RcFile,
    attachmentGroup: TipoComunicazioneFileAllegatoDTO,
  ) => {
    return (
      (await uploadAttachment?.(
        communication!.id!,
        attachmentGroup.id!,
        file,
      )) ?? false
    );
  };

  if (!attachmentGroupList || attachmentGroupList.length == 0) return null;

  return (
    <>
      <DividerTitleElement
        title={t('communication-attachments.title', 'Allegati')}
      />
      {attachmentGroupList.map(attachmentGroup => (
        <AttachmentGroupEditor
          taskId={taskId}
          key={attachmentGroup.id}
          communication={communication}
          attachmentGroup={attachmentGroup}
          removeAttachment={props.removeAttachment}
          attachExisting={attachExisting}
          onUpload={file => handleUpload(file, attachmentGroup)}
          disabled={disabled}
        />
      ))}
    </>
  );
};
